export const DOCUMENT_PROPERTIES_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Properties.DocumentPropertiesUpdated";
export const DOCUMENT_PROPERTIES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Properties.DocumentPropertiesInvalidated";
